import { difference } from "lodash";
import { useCallback, useState } from "react";
import { useFeatureFlag } from "../../../../launch-darkly";
import { usePlannerContext } from "../../Context";

type Props = {
  selectedCalendarIds: string[];
};

// For use in Provider
export const useStateAdditionalCalendarIds = ({
  selectedCalendarIds,
}: Props): [string[], (calendarIds: string[]) => void] => {
  const [additionalCalendarIds, setAdditionalCalendarIds] = useState<string[]>([]);
  const [multiCalScheduling] = useFeatureFlag("MultiCalScheduling");

  const handleAdditionalCalendarIdsChange = useCallback(
    (calendarIds: string[]) => {
      if (!multiCalScheduling) return;
      setAdditionalCalendarIds(difference(calendarIds, selectedCalendarIds));
    },
    [multiCalScheduling, selectedCalendarIds],
  );

  return [additionalCalendarIds, handleAdditionalCalendarIdsChange];
};

// For use in Consumer
export const useReadAdditionalCalendarIds = () => {
  const { additionalCalendarIds } = usePlannerContext();
  return additionalCalendarIds;
};

// For use in Consumer
export const useSetAdditionalCalendarIds = () => {
  const { setAdditionalCalendarIds } = usePlannerContext();
  return setAdditionalCalendarIds;
};
